module.exports = __webpack_public_path__ + "static/media/reauest-project-main-img@3x.086fdbfe.png";